import { Column } from '~/commonComponents/Column';
import { Text } from '~/commonComponents/Text';
import { EmptyWorkedWithProfessionalCopy } from '~/components/ProfessionalsHub/Constants';
import { Colors } from '~/themes/colors';

export const NoWorkedWith = () => {
  return (
    <Column alignItems="center">
      <EmptyWorkedWithProfessionalCopy.Icon size={136} />

      <Text bold color={Colors.neutral_500} fontSize={20} marginTop={18}>
        {EmptyWorkedWithProfessionalCopy.title}
      </Text>
      <Text color={Colors.neutral_500} marginTop={18} textAlign="center" width={392}>
        {EmptyWorkedWithProfessionalCopy.description}
      </Text>
    </Column>
  );
};
